import { createOpenItem, deleteOpenItem, queryOpenItemList, updateOpenItem } from '../services/openItem';

const BASE = 'OPEN_ITEM';

export const actions = {
  loadingOpenItem: `${BASE}_LOADING_OPEN_ITEM`,
  loadOpenItemSuccess: `${BASE}_LOAD_OPEN_ITEM_SUCCESS`,
  loadOpenItemFailed: `${BASE}_LOAD_OPEN_ITEM_FAILED`,

  creatingOpenItem: `${BASE}_CREATING_OPEN_ITEM`,
  createOpenItemSuccess: `${BASE}_CREATE_OPEN_ITEM_SUCCESS`,
  createOpenItemFailed: `${BASE}_CREATE_OPEN_ITEM_FAILED`,

  updatingOpenItem: `${BASE}_UPDATING_OPEN_ITEM`,
  updateOpenItemSuccess: `${BASE}_UPDATE_OPEN_ITEM_SUCCESS`,
  updateOpenItemFailed: `${BASE}_UPDATE_OPEN_ITEM_FAILED`,

  deletingOpenItem: `${BASE}_DELETING_OPEN_ITEM`,
  deleteOpenItemSuccess: `${BASE}_DELETE_OPEN_ITEM_SUCCESS`,
  deleteOpenItemFailed: `${BASE}_DELETE_OPEN_ITEM_FAILED`,
};

export const fetchOpenItemList =
  ({ restaurantId }) =>
  async (dispatch) => {
    dispatch({
      type: actions.loadingOpenItem,
    });

    let response;
    try {
      response = await queryOpenItemList({ restaurantId });
    } catch (e) {
      response = { success: false };
    }
    if (!response.success) {
      dispatch({
        type: actions.loadOpenItemFailed,
      });
      return;
    }

    dispatch({
      type: actions.loadOpenItemSuccess,
      payload: { openItems: response.data.data },
    });
  };

export const doCreateOpenItem =
  ({ restaurantId, ...data }, callback) =>
  async (dispatch) => {
    dispatch({
      type: actions.creatingOpenItem,
    });
    let response;
    try {
      response = await createOpenItem({ restaurantId, ...data });
    } catch (e) {
      response = { success: false };
    }
    typeof callback === 'function' && callback(response);

    if (!response.success) {
      dispatch({
        type: actions.createOpenItemFailed,
      });
      return;
    }

    dispatch({
      type: actions.createOpenItemSuccess,
    });

    dispatch(fetchOpenItemList({ restaurantId }));
  };

export const doUpdateOpenItem =
  ({ restaurantId, ...data }, callback) =>
  async (dispatch) => {
    dispatch({
      type: actions.updatingOpenItem,
    });

    let response;
    try {
      response = await updateOpenItem({ restaurantId, ...data });
    } catch (e) {
      response = { success: false };
    }
    typeof callback === 'function' && callback(response);
    if (!response.success) {
      dispatch({
        type: actions.updateOpenItemFailed,
      });
      return;
    }
    dispatch({
      type: actions.updateOpenItemSuccess,
    });
    dispatch(fetchOpenItemList({ restaurantId }));
  };

export const doDeleteOpenItem =
  ({ id, restaurantId }) =>
  async (dispatch) => {
    dispatch({
      type: actions.deletingOpenItem,
    });

    let response;
    try {
      response = await deleteOpenItem({ id, restaurantId });
    } catch (e) {
      response = { success: false };
    }
    if (!response.success) {
      dispatch({
        type: actions.deleteOpenItemFailed,
      });
      return;
    }

    dispatch({
      type: actions.deleteOpenItemSuccess,
    });

    dispatch(fetchOpenItemList({ restaurantId }));
  };
